import _Object$keys from "@babel/runtime-corejs3/core-js/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js/object/get-own-property-symbols";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js/instance/filter";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptor";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js/object/define-property";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
import _includesInstanceProperty from "@babel/runtime-corejs3/core-js/instance/includes";
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapFields } from "@joandvgv/vuex-map-fields";
import { defineComponent } from "@vue/composition-api";
export default defineComponent({
  name: "AutomationLevelTabs",
  computed: _objectSpread(_objectSpread({}, mapFields("AccountStore", ["accountPreferences.defaultListId", "accountPreferences.defaultEmailName", "accountPreferences.defaultEmailId"])), {}, {
    settingsToggleRoute() {
      const redirectTo = this.tabIsSettings ? "application-automations" : "application-automations-settings";
      return {
        name: redirectTo
      };
    },
    tabs() {
      return ["board", "application", "document"];
    },
    shouldShowSettings() {
      var _context;
      const settingsFilled = this.defaultListId;
      return _includesInstanceProperty(_context = this.$route.name).call(_context, "application-automations") && settingsFilled;
    },
    tabIsSettings() {
      var _context2;
      return _includesInstanceProperty(_context2 = this.$route.name).call(_context2, "settings");
    },
    tabIsDocumentAutomations() {
      var _context3;
      return _includesInstanceProperty(_context3 = this.$route.name).call(_context3, "document-automations");
    }
  }),
  methods: {
    getTabRoute(page) {
      return {
        name: `${page}-automations`
      };
    },
    getTabTitle(page) {
      return this.$t("automations.levels")[page];
    }
  }
});